export function formatGameTime(gameTime: number): string {
  const hours = Math.floor(gameTime / 3600);
  const minutes = Math.floor((gameTime % 3600) / 60);
  const seconds = gameTime % 60;

  if (hours > 0) {
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  }

  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

export function getTimeDescriptor(formattedGameTime: string): string {
  // Use "seconds", "minutes", or "hours" to describe the game time depending
  // on the total.
  const timeDescriptor =
    formattedGameTime.length <= 5
      ? formattedGameTime.startsWith("00")
        ? "seconds"
        : "minutes"
      : "hours";

  return timeDescriptor;
}

export function formatPublishDate(date: string): string {
  // Publish date is in the format "YYYY-MM-DD"
  const [year, month, day] = date.split("-");
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return `${months[Number(month) - 1]} ${day}, ${year}`;
}
